import { ApiError } from './chunk-LEGW4QDU.js';

// src/internal/auth/createRestAuthAdapter.ts
function createRestAuthAdapter(opts, meOptions = {}) {
  const { api, basePath = "/auth" } = opts;
  const treat401AsLoggedOut = meOptions.treat401AsLoggedOut ?? true;
  function url(action) {
    return `${basePath}${action}`;
  }
  async function jsonRequest(method, path, body) {
    const init = { method };
    if (body !== void 0) {
      init.headers = { "Content-Type": "application/json" };
      init.body = JSON.stringify(body);
    }
    return api.request(path, init);
  }
  return {
    async login(input) {
      return jsonRequest("POST", url("/login"), input);
    },
    async logout() {
      await jsonRequest("POST", url("/logout"));
    },
    async me() {
      try {
        return await jsonRequest("GET", url("/me"));
      } catch (err) {
        if (treat401AsLoggedOut && err instanceof ApiError && err.status === 401) {
          return null;
        }
        throw err;
      }
    },
    async changePassword(input) {
      await jsonRequest("POST", url("/change-password"), {
        current_password: input.oldPassword,
        new_password: input.newPassword
      });
    }
  };
}

export { createRestAuthAdapter };
//# sourceMappingURL=auth-rest-default.js.map
//# sourceMappingURL=auth-rest-default.js.map